import { render, staticRenderFns } from "./page-referral-rules.vue?vue&type=template&id=31b9fa18"
import script from "./page-referral-rules.vue?vue&type=script&lang=ts"
export * from "./page-referral-rules.vue?vue&type=script&lang=ts"
import style0 from "./page-referral-rules.vue?vue&type=style&index=0&id=31b9fa18&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports